import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./App.css";
import { gql, useQuery } from "@apollo/client";

const queryTicket = gql`
  query ticket($token: String, $ticket: String) {
    ticket(token: $token, ticket: $ticket) {
      uuid
      grantedAt
      createdAt
      url
      currentPosition {
        position
        waitingMinutes
      }
    }
  }
`;

function App() {
  const [options, setOptions] = useState<
    { token: string | null; ticket: string | null } | undefined
  >();

  const { data, loading, refetch } = useQuery(queryTicket, {
    variables: options,
    skip: !options,
    // pollInterval: 20,
  });

  // manage ticket in localstorage
  useEffect(() => {
    if (data?.ticket?.uuid) {
      if (options) {
        setOptions({ ...options, ticket: data.ticket.uuid });
        localStorage.setItem("ticket", data.ticket.uuid);
      }
    } else {
      const searchParams = new URLSearchParams(document.location.search);
      const options: { token: string | null; ticket: string | null } = {
        token: null,
        ticket: null,
      };
      if (searchParams.has("token")) {
        options.token = searchParams.get("token");
      }
      if (searchParams.has("ticket")) {
        options.ticket = searchParams.get("ticket");
      } else if (localStorage.getItem("ticket")) {
        options.ticket = localStorage.getItem("ticket");
      }
      setOptions(options);
    }
  }, [data]);

  useEffect(() => {
    if (data?.ticket?.url) {
      window.location.href = data.ticket.url;
    }
  }, [data]);

  // manage reload
  const [duration, setDuration] = useState(20);
  useEffect(() => {
    setInterval(() => {
      setDuration((duration) => {
        if (duration === 1) {
          refetch();
        }
        return duration - 1 || 20;
      });
    }, 1000);
  }, []);

  // manage dark mode
  const [darkOn, setDarkOn] = useState(!!localStorage.getItem("darkOn"));
  function onToggleMode() {
    document.body.classList.toggle("dark");
    if (darkOn) {
      localStorage.removeItem("darkOn");
    } else {
      localStorage.setItem("darkOn", "1");
    }
    setDarkOn(!darkOn);
  }
  useEffect(() => {
    if (darkOn) {
      document.body.classList.toggle("dark");
    }
  }, []);

  return (
    <div className="main">
      <h2>Bienvenu sur INKK Tickets</h2>
      {data?.ticket?.url ? (
        <p>
          Merci d'avoir patienté, vous allez être redirigé vers INKK Hébergement
          pour poursuivre votre demande de réservation de logement INSA. Si la
          redirection ne s'effectue pas correctement, vous pouvez{" "}
          <a href={data?.ticket?.url}>cliquer ici</a>.
          <br />
          <br />
          <strong>Attention,</strong> n'oubliez pas de bien activer votre VPN ou
          d'être connecté au réseau INSA pour accéder à INKK Hébergement.
        </p>
      ) : (
        <>
          <p>
            Vous avez été positionné dans la file d'attente. Une fois votre
            tour, vous serez automatiquement redirigé vers INKK Hébergement pour
            procéder à la réservation de votre logement
          </p>
          <p>
            <strong>Attention,</strong> tous les tickets validés avant l'horaire
            d'ouverture de la campagne seront invalidés. Actualisez cette page à
            l'heure d'ouverture de la campagne (20h00, heure française).
          </p>
          <div className="cards">
            <div className="card">
              <h4>Position</h4>
              <p>
                {data && data.ticket.currentPosition.position !== -1
                  ? data.ticket.currentPosition.position
                  : "..."}
              </p>
            </div>
            <div className="card">
              <h4>Temps d'attente estimé</h4>
              <p>
                {data
                  ? `${data.ticket.currentPosition.waitingMinutes} minutes`
                  : "..."}
              </p>
            </div>
          </div>
          <p className="time">
            {loading ? (
              <>Chargement</>
            ) : (
              <>Prochaine actualisation dans {duration} secondes </>
            )}
          </p>
        </>
      )}
      <p>
        Votre ticket est stocké sur votre navigateur. Tant que vous utilisez le
        même appareil, avec le même navigateur internet, sans navigation privée,
        vous pouvez quitter le site et revenir, votre position sera conservée.
      </p>
      <div className="links">
        <div>{data && <p>Ticket n°{data.ticket.uuid.slice(0, 8)}</p>}</div>
        <div>
          <a onClick={onToggleMode} href="#">
            Mode {darkOn ? "clair" : "sombre"}
          </a>
          {"  "}
          <a href="mailto:contact@inkk.io">Contactez-nous</a>
        </div>
      </div>
    </div>
  );
}

export default App;
